import React from 'react';
import { Link } from 'react-router-dom';
import { Article } from '../types';

interface ContentBlockProps {
  article: Article;
  featured?: boolean;
}

const ContentBlock: React.FC<ContentBlockProps> = ({ article, featured }) => {
  return (
    <Link
      to={`/article/${article.id}`}
      className={`group block overflow-hidden ${featured ? 'md:col-span-2' : ''}`}
    >
      <div className={`relative aspect-[4/5] overflow-hidden bg-gray-100 ${featured ? 'md:aspect-[16/9]' : ''}`}>
        <img
          src={article.heroImage || '/assets/placeholder.svg'}
          alt={article.title}
          onError={(e) => {
            const t = e.currentTarget;
            if (!t.dataset.fallback) { t.dataset.fallback = '1'; t.src = '/assets/placeholder.svg'; }
          }}
          className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 opacity-90 group-hover:opacity-100 transition-all duration-500"
        />
        <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors" />

        {/* Floating Labels */}
        <div className="absolute top-4 left-4 space-y-1">
          <span className="bg-white text-black px-2 py-1 text-[10px] font-mono font-bold tracking-widest uppercase inline-block">
            {article.type}
          </span>
        </div>
      </div>
      
      <div className="pt-4 space-y-2">
        <h3 className="font-heading font-bold text-xl md:text-2xl leading-none uppercase tracking-wide group-hover:underline decoration-2 underline-offset-4">
          {article.title}
        </h3>
        {article.subtitle && (
          <p className="font-body text-gray-500 text-xs md:text-sm line-clamp-2">
            {article.subtitle}
          </p>
        )}
      </div>
    </Link>
  );
};

export default ContentBlock;
